<!--
左侧附带树的公共面板组件
-->
<template>
  <a-row :gutter="10">
    <a-col :md="this.treeWidth" :sm="24">
      <a-card :bordered="false">
        <div style="background: #fff;padding-left:16px;height: 100%; margin-top: 5px;max-height:732px;overflow: scroll">
          <a-input-search @search="onSearch" style="width:100%;margin-top: 10px" placeholder="请输入关键字"/>
          <!-- 树-->
          <template v-if="departTree.length>0">
            <!--左侧树-->
            <a-tree
              showLine
              :selectedKeys="selectedKeys"
              :checkStrictly="true"
              @select="onSelect"
              :dropdownStyle="{maxHeight:'200px',overflow:'auto'}"
              :treeData="departTree"
              :autoExpandParent="autoExpandParent"
              :expandedKeys="iExpandedKeys"
              @expand="onExpand"
            />

          </template>
          <div style="margin-top: 24px;" v-else><h3>暂无有效节点信息</h3></div>
        </div>
      </a-card>
    </a-col>
    <a-col :md="24-this.treeWidth" :sm="24">
      <a-card :bordered="false">
        <slot></slot>
      </a-card>
    </a-col>
  </a-row>
</template>
<script>
  import {queryMyDepartTreeList, searchByKeywords} from '@/api/api'

  export default {
    name: 'XTreePanel',
    props: {
      data: {
        type: Array,
        require: false
      },
      treeWidth: {
        type: Number,
        default: 5
      }
    },
    components: {
    },
    data() {
      return {
        iExpandedKeys: [],
        loading: false,
        autoExpandParent: true,
        disable: true,
        treeData: [],
        treeCopy: [],
        visible: false,
        departTree: [],
        hiding: true,
        model: {},
        dropTrigger: '',
        depart: {},
        disableSubmit: false,
        checkedKeys: [],
        selectedKeys: [],
        autoIncr: 1,
        currSelected: {}
      }
    },
    methods: {
      loadData() {
        this.refresh();
      },
      clearSelectedDepartKeys() {
        this.checkedKeys = [];
        this.selectedKeys = [];
      },
      loadTree() {
        if(!this.data) return;
        
        this.treeData = this.data;
        this.departTree = this.data;
        this.treeCopy = JSON.parse(JSON.stringify(this.data));
        this.setThisExpandedKeys(this.data);
      },
      setThisExpandedKeys(node) {
        if(Array.isArray(node)){
          for (const key in node) {
            const element = node[key];
            this.setThisExpandedKeys(element);
          }
          return;
        }

        //只展开一级目录
        if (node.children && node.children.length > 0) {
          this.iExpandedKeys=[];
          this.iExpandedKeys.push(node.key)
          //下方代码放开注释则默认展开所有节点
          /**
          for (let a = 0; a < node.children.length; a++) {
            this.setThisExpandedKeys(node.children[a])
          }
          */
        }
      },
      refresh() {
        this.loading = true
        this.loadTree()
      },

      onExpand(expandedKeys) {
        // console.log('onExpand', expandedKeys)
        // if not set autoExpandParent to false, if children expanded, parent can not collapse.
        // or, you can remove all expanded children keys.
        this.iExpandedKeys = expandedKeys
        this.autoExpandParent = false
      },

      onSearch(value) {
        let that = this
        if (value) {
          this.departTree = [];
          this.searchNode(this.departTree, this.treeCopy, value);
        } else {
          that.loadTree()
        }

      },
      searchNode(currNode, treeData, filter){
        var that = this;
        for (var i=0; Array.isArray(treeData) && i<treeData.length; i++) {
          var item = treeData[i];
          if(item.title.indexOf(filter) > -1){
            var currChildren = [];
            that.searchNode(currChildren, item.children, filter);
            item.children = currChildren;
            currNode.push(item);
            that.iExpandedKeys.push(item.key);
          }else{
            var itemNode = [];
            that.searchNode(itemNode, item.children, filter);
            if(itemNode.length > 0){
              var filtered = {};
              for(var attr in item){
                filtered[attr] = item[attr];
              }
              filtered.children = itemNode;
              currNode.push(filtered);
              that.iExpandedKeys.push(filtered.key);
            }
          }

        }
      },
      onSelect(selectedKeys, e) {
        if (this.selectedKeys[0] !== selectedKeys[0]) {
          this.selectedKeys = [selectedKeys[0]];
        }
        let record = e.node.dataRef;
        this.checkedKeys.push(record.id);
        this.$emit('selected', {"record":record,"selectedKeys":selectedKeys});
      },
    },
    watch: {
      data: {
        imediate: true,
        handler(){
          this.loadTree();
        }
      }
    },
    created() {
      this.currFlowId = this.$route.params.id
      this.currFlowName = this.$route.params.name
      this.loadTree()
    },
  }
</script>
<style scoped>
  @import '~@assets/less/common.less'
</style>